<app-sidebar-sorting />
<app-sidebar-search [itemsInnerComponent]="itemsInnerComponent()" />
